<template>
  <div class="templates__header">
    <template v-if="template !== null">
      <div class="templates__icon">
        <i :class="template.icon"></i>
      </div>
      <div class="templates__header-content">
        <div class="templates__header-title">
          {{ template.name }}
          <small v-if="category !== null">{{ category.name }}</small>
          <span v-if="installed" class="templates__installed-badge">
            {{ $t('templateHeader.installed') }}
          </span>
        </div>
      </div>
      <div class="templates__install">
        <Button
          :loading="installing"
          :disabled="installing"
          @click="$emit('use-template')"
          >{{
            installed
              ? $t('templateConfirmModal.openInstalled')
              : $t('templateHeader.use')
          }}</Button
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TemplateHeader',
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    template: {
      required: true,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    category: {
      required: true,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    installing: {
      type: Boolean,
      default: false,
    },
    installed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
